const IMEI_CHECKER_I18N = {
  en: {
    validationEmpty: 'Please enter your IMEI number',
    validationTooShort: 'IMEI must be at least 14 digits',
    checking: 'Checking…',
    deviceNotFound: 'Device not found',
    networkError: 'Network error — please try again.',
    genericError: 'Something went wrong, please try again.',
    checkAnotherDevice: 'Check another device',
  },
  fr: {
    validationEmpty: 'Veuillez entrer votre numéro IMEI',
    validationTooShort: 'Le numéro IMEI doit comporter au moins 14 chiffres',
    checking: 'Vérification…',
    deviceNotFound: 'Appareil introuvable',
    networkError: 'Erreur de réseau — veuillez réessayer.',
    genericError: 'Une erreur est survenue, veuillez réessayer.',
    checkAnotherDevice: 'Vérifier un autre appareil',
  },
}

export default IMEI_CHECKER_I18N
